import { useNavigate } from "react-router-dom";
import { useAppSelector } from "./redux";

export const useNavigateLogin = () => {
  const { isLogin } = useAppSelector((state) => state.globalReducer);

  const navigate = useNavigate();
  const navigateLogin = () => {
    navigate("/login");
  };
  return { isLogin, navigateLogin };
};

export const useNavigateReplace = () => {
  const navigate = useNavigate();
  const navigateReplaceParams = (params: { [key: string]: string }) => {
    const url = new URL(window.location.href);
    for (let key in params) {
      if (params[key]) {
        url.searchParams.set(key, params[key]);
      }
    }

    navigate(url.pathname + url.search);
  };
  return { navigateReplaceParams };
};
